export enum UserRole {
  USER = 'organization_member',
  ORGANIZATION_ADMIN = 'organization_admin',
  SYSTEM_ADMIN = 'system_admin',
}

export enum UserInvitationStatus {
  PENDING = 0,
  ACCEPTED = 10,
  CANCELLED = -10,
}
